import React, { PropTypes } from 'react';
import FileUploadForm from 'common/components/form/file_upload_form';
import { PORTFOLIO_FORM_STEPS, PORTFOLIO_FORM_FLOW } from 'common/variables';
import UploadForm from 'profile/components/portfolio/form_get_entries';
import FormInfoStep from 'profile/components/portfolio/form_info_step';
import FormButtons from 'common/components/form/modal_form_buttons';

export default class PortfolioForm extends FileUploadForm {
  constructor(props) {
    super(props);

    this.setFile = super.setFile.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.toggleForm = this.toggleForm.bind(this);
    this.resetState = this.resetState.bind(this);
    this.changeFormEntryImage = this.changeFormEntryImage.bind(this);
    this.createRevisionPortfolio = this.createRevisionPortfolio.bind(this);
  }

  getInitialFormState() {
    const state = {
      entry: {
        title: '',
        description: '',
        file: '',
        thumbnail: '',
        category: null,
        sub_category: null,
        tags: [],
        revisionId: null,
      },
      fromRevision: false,
    };

    return state;
  }

  resetState() {
    const state = this.getInitialFormState();
    this.setState({
      ...state,
    });
  }

  getCurrentStep(props) {
    return props.currentStep;
  }

  selectFormEntry(entryData, fromRevision) {
    this.setState({
      entry: {
        ...this.state.entry,
        ...entryData
      },
      fromRevision: fromRevision || false,
    });
  }

  changeFormEntryImage() {
    this.props.changeStep(PORTFOLIO_FORM_STEPS.select);
  }

  submitForm(fieldsData) {
    const { user, formData, fetchAllPortfolioEntries } = this.props;
    const { entry } = this.state;
    const revisionObject = formData.revision || {};

    const dataObject = {
      sub_category: fieldsData.portfolio_subcategory,
      industry: fieldsData.portfolio_industry,
      title: fieldsData.portfolio_title,
      description: fieldsData.portfolio_description,
      tags: [],
    };

    if (entry.file) {
      dataObject.image = entry.file;
    }

    // we're updating a revision entry
    if (revisionObject.id) {
      this.props.updatePortfolioEntry(dataObject, user.profile_data.username, revisionObject.id)
      .then(() => {
        this.resetState();
        this.props.toggleForm();
        // FIXME: we wait 1.5s until this entry is indexed on ES - figure out a better approach
        setTimeout(() => fetchAllPortfolioEntries(user.profile_data.username), 1500);
      })
      .catch((err) => {
        this.props.setBannerError('Error creating portfolio entry', JSON.stringify(err.data));
      });
    } else {
      this.props.createPortfolioByUpload(dataObject, user.profile_data.username)
      .then(() => {
        this.resetState();
        this.props.toggleForm();
        // FIXME: we wait 1.5s until this entry is indexed on ES - figure out a better approach
        setTimeout(() => fetchAllPortfolioEntries(user.profile_data.username), 1500);
      })
      .catch((err) => {
        this.props.setBannerError('Error updating portfolio entry', JSON.stringify(err.data));
      });
    }
  }

  createRevisionPortfolio() {
    const formData = {
      revision_id: this.state.entry.revisionId,
    };

    this.props.createPortfolioByRevision(formData, this.props.user.profile_data.username)
    .then((resp) => {
      this.props.saveFormRevisionObject({
        ...this.state.entry,
        ...resp,
      });
      this.props.changeStep(PORTFOLIO_FORM_STEPS.info);
    })
    .catch((err) => {
      this.props.setBannerError('Error creating portfolio entry', err);
    });
  }

  getFormStyleNames() {
    return 'portfolio-edit wide';
  }

  getMobileStep() {
    return null;
  }

  toggleForm() {
    this.resetState();
    this.props.changeStep(PORTFOLIO_FORM_FLOW[0]);
    this.props.clearFormRevisionObject();
    this.props.toggleForm();
  }

  getTitle() {
    return "Add Portfolio Item";
  }

  getFormStep() {
    const { currentStep, changeStep, saveEntryForm, categories,
      formData, formValues } = this.props;
    const { entry, fromRevision } = this.state;
    const steps = {};
    let submitButtonActive = false;
    if (formValues && formValues.portfolio_title && formValues.portfolio_description &&
        formValues.portfolio_subcategory && formValues.portfolio_industry) {
      submitButtonActive = true;
    }

    for (const k of Object.keys(PORTFOLIO_FORM_STEPS)) {
      let element = null;
      let formButtons = null;

      if (k === 'select') {
        let manualAction = false;
        if (fromRevision) {
          manualAction = this.createRevisionPortfolio;
        }

        formButtons = (
          <FormButtons
            currentStep={currentStep}
            nextActive={!!entry.thumbnail}
            formSteps={PORTFOLIO_FORM_FLOW}
            manualAction={manualAction}
            changeStep={changeStep}
            onToggleDialog={this.toggleForm}
          />
        );

        element = (
          <UploadForm
            key={`pf_step_${k}`}
            entries={formData.entries}
            fetchData={this.props.fetchUserEntries}
            onCrop={this.setFile}
            onChangeEntry={this.selectFormEntry}
            formButtons={formButtons}
            categories={categories}
          />
        );
      } else if (k === 'info') {
        formButtons = (
          <FormButtons
            currentStep={currentStep}
            manualAction={saveEntryForm}
            nextActive={submitButtonActive}
            onToggleDialog={this.toggleForm}
          />
        );

        element = (
          <FormInfoStep
            key={`pf_step_${k}`}
            entry={entry}
            formButtons={formButtons}
            onFormSubmit={this.submitForm}
            onChangeEntry={this.changeFormEntryImage}
          />
        );
      }

      steps[k] = element;
    }

    return steps[this.props.currentStep];
  }
}

PortfolioForm.propTypes = {
  user: PropTypes.object,
  categories: PropTypes.array,
  entries: PropTypes.array,
  currentStep: PropTypes.string,
  formData: PropTypes.object,
  formOpen: PropTypes.bool,
  formValues: PropTypes.object,
  toggleForm: PropTypes.func,
  changeStep: PropTypes.func,
  fetchUserEntries: PropTypes.func,
  saveEntryForm: PropTypes.func,
  saveFormRevisionObject: PropTypes.func,
  clearFormRevisionObject: PropTypes.func,
  updatePortfolioEntry: PropTypes.func,
  createPortfolioByRevision: PropTypes.func,
  createPortfolioByUpload: PropTypes.func,
  setBannerError: PropTypes.func,
  fetchAllPortfolioEntries: PropTypes.func,
};



// WEBPACK FOOTER //
// ./profile/components/portfolio/portfolio_form.jsx